import { makeGetActiveAreas, makeGetAllAreas } from '../dsa/areaSelectors';
import { getAbilities } from '../dsa/abilitiesSelectors';
import { createSelector } from 'reselect';

const getActiveAreas = makeGetActiveAreas();

const getAllAreas = makeGetAllAreas();

const buildGroupedKeyGoals = (area, analysisGoals, dsaGoals, dsaGoalAnswers) => {
  return {
    id: area.id,
    active: area.active,
    title: area.title,
    goals: analysisGoals
      .filter(ag => ag.area === area.id)
      .map(ag => {
        const dsaGoalAnswer = dsaGoalAnswers.find(answer => answer.goal === ag.goal);
        const dsaGoal = dsaGoals.find(goal => ag.goal === goal.id);

        return Object.assign({}, ag, {
          answer: dsaGoalAnswer && dsaGoalAnswer.answer,
          order: dsaGoal && dsaGoal.order
        });
      })
      .sort((a, b) => a.order > b.order)
  };
};

const getDSAGoals = state => {
  return state.dsaConfig.goals;
};

const getDSAGoalAnswers = state => {
  return state.dsa && state.dsa.dsaGoals;
};

const getAnalysisGoals = state => {
  return state.dsaConfig.analysisGoals;
};

export const getGroupedKeyGoalsWithAnswers = createSelector(
  [getActiveAreas, getAnalysisGoals, getDSAGoals, getDSAGoalAnswers],
  (activeAreas, analysisGoals, dsaGoals, dsaGoalAnswers) => {
    return activeAreas.map(area => {
      return buildGroupedKeyGoals(area, analysisGoals, dsaGoals, dsaGoalAnswers);
    });
  }
);

export const getGroupedKeyGoalsWithAnswersPPTX = createSelector(
  [getAbilities, getAllAreas, getAnalysisGoals, getDSAGoals, getDSAGoalAnswers],
  (abilities, allAreas, analysisGoals, dsaGoals, dsaGoalAnswers) => {
    return allAreas
      .filter(abilities.canActivateArea)
      .map(area => {
        return buildGroupedKeyGoals(area, analysisGoals, dsaGoals, dsaGoalAnswers);
      });
  }
);

export const getKeyGoalsCount = createSelector(
  [getGroupedKeyGoalsWithAnswers],
  (groupedKeyGoals) => (
    groupedKeyGoals
      .reduce((_, area) => _.concat(area.goals), [])
      .reduce((_, goal) => goal.answer ? _ + 1 : _, 0)
  )
);




// WEBPACK FOOTER //
// ./src/selectors/analytics/goalsSelector.js